export const defaultFormData = {
    stitchLayout: {
        type: 2,
        value: {
            chooseValue: '2-1'
        }
    },
    stitchTargetCount: {
        type: '1',
        value: {
            totalNum: 2,
            uploadList: []
        }
    },
    // 尺寸
    sizeControl: {
        // 选择：choose
        // 自定义：'custom'
        type: 'choose',
        value: {
            ratio: '1:1',
            dimension: '600*600',
            customWidth: '',
            customHeight: ''
        }
    },
    stitchSpace: {
        value: '0'
    }
};